import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import AnomalaView from "../views/AnomalaView.vue";
import BroomxView from "../views/BroomxView.vue";
import ModernView from "../views/ModernView.vue";
import SenseView from "../views/SenseView.vue";
import UnitsView from "../views/UnitsView.vue";
import WildtechView from "../views/WildtechView.vue";
import PresentacioView from "../views/PresentacioView.vue";
import ProjectsView from "../views/ProjectsView.vue"


Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/prova",
    name: "anomala",
    component: AnomalaView,
  },
  {
    path: "/broomx",
    name: "broomx",
    component: BroomxView,
  },
  {
    path: "/modern",
    name: "modern",
    component: ModernView,
  },
  {
    path: "/sense",
    name: "sense",
    component: SenseView,
  },
  {
    path: "/units",
    name: "units",
    component: UnitsView,
  },
  {
    path: "/presentacio",
    name: "presentacio",
    component: PresentacioView,
  },
  {
    path: "/wildtech",
    name: "wildtech",
    component: WildtechView,
  },
  {
    path: "/projects",
    name: "projects",
    component: ProjectsView,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
